<template>
<div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.alert.panic.label.title')}}</h4>
                            </div>
                        </div>
                    </div>
                    <!-- Form row -->
                    <div class="row" v-if="data._id">
                        <div class="col-md-12">
                            <div class="card-box">
                                <form>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.alert.label.name')}}
                                            </label>
                                            <input type="text" v-model="data.systemUser.firstName" class="form-control" readonly="true">
                                        </div>
                                         <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.alert.label.lastname')}}
                                            </label>
                                            <input type="text" v-model="data.systemUser.lastName" class="form-control" readonly="true">
                                        </div>
                                    </div>
                                     <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.alert.label.email')}}
                                            </label>
                                            <input type="text" v-model="data.systemUser.email" class="form-control" readonly="true">
                                        </div>
                                         <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.alert.label.phone')}}
                                            </label>
                                            <input type="text" v-model="data.systemUser.primaryPhone" class="form-control" readonly="true">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.alert.label.data')}}
                                            </label>
                                            <input type="text" :value="`${new Date(data.date).toLocaleDateString()} - ${new Date(data.date).toLocaleTimeString()}`" class="form-control" readonly="true">
                                        </div>
                                         <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.alert.label.status')}}
                                            </label>
                                            <input v-if="data.status =='ACTIVE'" type="text" :placeholder="$t('string.alert.status.active')"  class="form-control" readonly="true">
                                            <input v-else-if="data.status =='CLOSED'" type="text" :placeholder="$t('string.alert.status.closed')"  class="form-control" readonly="true">
                                        </div>
                                    </div>
                            
                                    <label for="inputAddress" class="col-form-label">
                                        {{$t('string.msg.alert.label.map')}}
                                    </label>
                                   
                                    <div class="card-header form-row">
                                        <GmapMap class="form-group col-md-12"
                                            :center="{lng:data.latitude, lat:data.longitude}"
                                            :zoom="15"
                                            :map-type-id="terrain"
                                            style="width: 2140px; height: 300px"
                                        >
                                            <GmapMarker
                                                :key="index"
                                                :position="{lng:data.latitude, lat:data.longitude}"
                                                :clickable="true"
                                                :draggable="true"
                                                @click="center=m.position"
                                            />
                                        </GmapMap>
                                    </div>
                                    <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                        </ul>
                                    </div>
                                    <br/><br/>
                                      <div class="d-flex justify-content-between bd-highlight mb-3">
                                        <button @click="clearForm" class="btn btn-secondary w-20">{{$t('string.msg.form.btn.clear')}}</button>
                                        <!-- <button v-show="data.status == 'ACTIVE'" @click="add" class="btn btn-warning w-20 text-dark-gray">{{$t('string.msg.btn.alert.label.chat')}}</button> -->
                                        <!-- <button v-show="data.status == 'ACTIVE'" @click="checkForm" class="btn btn-danger w-20">{{$t('string.msg.btn.alert.label.problem')}}</button> -->
                                    </div>
                                    <div class="col-md-12" v-show="data.status == 'CLOSED'">
                                        <h2 class="text-center">{{$t('string.msg.alert.closed.title')}}</h2>
                                    </div>
                                </form>
                                </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem"/>
                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" v-on:confirmation-return="archive"/>
    </div>
</template>

<script>
import Controller from './CrtAlert';
import List from './ListAlert';
import Confs from '../../../components/common/Confs';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Confirmation from '../../../components/layout/Confirmation';
import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from 'vue'

Vue.use(VueGoogleMaps, {
  load: {
    key: Confs.KEY_MAPS,
    libraries: 'places', 
  }
});

export default {
  name: 'Alert',
  components: {
    Spinner,
    Toast,
    List,
    Confirmation
  },
  data() {
      return {
        errors: [],
        addresses: [],
        valuekey: 0,
        types: [
            {_id:"PART_SUPPLIER", name:this.$t('string.msg.company.label.type.autoparts')},
            {_id:"CERTIFIER", name:this.$t('string.msg.company.label.type.certifier')},
            {_id:"SERVICE_PROVIDER", name:this.$t('string.msg.company.label.type.serviceprovider')}
        ],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        
        data: {
            status: "ACTIVE",
            isBranch: false,
            markers: [{
                lat: -46.6786903,
                lgn: -23.6308406
            }],
            fantasyName: null,
            socialName: null,
            email: null,
            document: null,
            address: {
                state: -1,
                cep: null,
                city: null,
                address: null,
                neighborhood: null,
                number: null
            },
            primaryPhone: null,
            typeService: [],
        }
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
  },
  mounted(){
  }
}
</script>

<style>
</style>
